import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { debugLog, isDebugLogEnabled } from './debug-log';

/**
 * Log every page leave / enter.
 * Controlled by environment.debugLog.enabled / .router
 */
export function provideRouteDebugLog(): EnvironmentProviders {
  return provideAppInitializer(() => {
    if (!isDebugLogEnabled('router')) return;

    const router = inject(Router);
    let startedAt = 0;

    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        startedAt = performance.now();
        if (router.url && router.url !== event.url) {
          debugLog('router', `← LEAVE ${router.url}`);
        }
        return;
      }

      const elapsed = `${Math.round(performance.now() - startedAt)}ms`;
      if (event instanceof NavigationEnd) {
        debugLog('router', `→ ENTER ${event.urlAfterRedirects} (${elapsed})`);
      } else if (event instanceof NavigationCancel) {
        debugLog('router', `✕ CANCEL ${event.url} (${elapsed})`, { reason: event.reason });
      } else if (event instanceof NavigationError) {
        debugLog('router', `✕ ERROR ${event.url} (${elapsed})`, { error: event.error });
      }
    });
  });
}
